








import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import Spinner from '../inlearno';

type BooleanOrNull = boolean | null;

@Component({
  components: {
    Spinner,
  },
})
export default class ComponentsSpinnersWrapper extends Vue {
  // Props
  @Prop({ type: [Boolean, Number, String], default: 33 })
  readonly size!: false | number | string;

  @Prop({ type: Boolean, default: false })
  height: false;

  @Prop({ type: Boolean, default: false })
  showContent: BooleanOrNull;

  @Prop({ default: '', type: String }) wrapperClass: string;

  flag: BooleanOrNull = false;

  @Watch('showContent')
  changeData(value: BooleanOrNull) {
    this.flag = value;
  }

  mounted() {
    this.$nextTick(() => {
      this.flag = this.showContent;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/spinners/swrapper/Swrapper.vue